import Vue from 'vue'
import App from './App.vue'
import moment from 'moment'
import wx from 'weixin-js-sdk'

Vue.config.productionTip = false

Vue.filter('formatDate', function (value) {
  if (!value) return ''
  return moment(value.toString().ISO_8601).format('MM/DD/YYYY hh:mm')
})

Vue.use(wx)

new Vue({
  render: h => h(App),
}).$mount('#app')
